import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-catalogs-new-product-creation-card',
  templateUrl: './catalogs-new-product-creation-card.component.html',
  styleUrls: ['./catalogs-new-product-creation-card.component.scss']
})
export class CatalogsNewProductCreationCardComponent implements OnInit {

  @Input() preparations;
  @Input() magnitudes;
  showButton: boolean;
  productForm = new FormGroup({
    gtin: new FormControl(null, Validators.required),
    internalCode: new FormControl(null, Validators.required),
    additionalInfo: new FormControl(null, Validators.required),
    category: new FormControl(null, Validators.required),
    categoryCode: new FormControl(null, Validators.required),
    image: new FormControl(null, Validators.required),
    active: new FormControl(true, Validators.required),
    tradename: new FormControl(null, Validators.required),
    qty: new FormControl(null, Validators.required),
    magnitude: new FormControl('ud', Validators.required),
    price: new FormControl(null, Validators.required),
    offerPrice: new FormControl(null, Validators.required),
    tax: new FormControl(null, Validators.required),
    description: new FormControl(null, Validators.required)
  });
  selectedPreparations;
  addNewCenterSubscription: Subscription;

  constructor(private spinnerService: SpinnerService,
              private snackbarService: SnackBarService,
              private router: Router,
              private dialog: MatDialog,
              private activatedRoute: ActivatedRoute,
              private productsService: ProductsService
              ) {
    this.showButton = true;
  }

  ngOnInit() { }

  public addNewProduct() {
    this.showButton = false;
    this.spinnerService.show('product-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewCenterSubscription = this.productsService.addNewProduct(this.productForm, this.getPreparationsInternalIds(this.selectedPreparations)).subscribe(
        (res) => {
          this.showButton = true;
          this.spinnerService.hide('product-new-spinner');
          this.snackbarService.open('catalogs-page.snackbar messages.add product success', 'success');
          this.router.navigate(['../products'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('product-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public cancelProduct() {
    this.router.navigate(['../products'], { relativeTo: this.activatedRoute.parent });
  }

  public validateForm() {
    if (!this.productForm.get('image').valid) {
      return 'catalogs-page.snackbar messages.image products error';
    }  else if (!this.productForm.get('gtin').valid) {
      return 'catalogs-page.snackbar messages.gtin products error';
    }  else if (!this.productForm.get('description').valid) {
      return 'catalogs-page.snackbar messages.description products error';
    } else {
      return true;
    }
  }

  public duallistboxOutputEventReceiver(selectedPreparations) {
    const aux = new Array();
    for (const d of selectedPreparations) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedPreparations = aux;
    }
  }

  public getPreparationsInternalIds(preparations) {
    if (preparations && (preparations.length > 0)) {
      return preparations.map(p => p.InternalId);
    } else {
      return [];
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.productForm.patchValue({
            image: result[0].Url
          });
        }
      }
    );
  }

  public generateCodes() {
    const timestamp = moment().valueOf();
    this.productForm.patchValue({
      gtin: timestamp.toString(),
      internalCode: timestamp.toString() + 'i'
    });
  }
}
